import { sendBugsnagError } from "@utils/Bugsnag";
import { getConfiguration } from "@helpers/site_configuration";
import axios from "axios";

const currentConfig = getConfiguration();
const BULK_CONTACT_ENDPOINT = currentConfig.bulkContactFormURL;

export const submitBulkContactForm =
  payload =>
  async (dispatch, getState, api) => {
    try {
      const config = {
        withCredentials: false
      };
      const response = await axios.post(BULK_CONTACT_ENDPOINT, {data: payload}, config);
      if (response.status === 200) {
        return { success: true };
      } else {
        const message = "We were unable to send your message. Please try again.";
        return { success: false, error: message };
      }
    } catch (error) {
      sendBugsnagError(error, "actions/submitBulkContactForm");
      const message = "We were unable to send your message. Please try again.";
      return { success: false, error: message };
    }
  };
